import React from 'react'
import PropTypes from 'propTypes'

import { useToast } from './useToast'
import { ToastContext } from './ToastContext'
import Toast from './Toast'

const ToastProvider = ({ children }) => {
  const { visibleToast, showToast, hideToast } = useToast()

  const value = React.useMemo(() => {
    return {
      showToast,
    }
  }, [showToast])

  return (
    <ToastContext.Provider value={value}>
      <Toast theme={visibleToast?.theme} message={visibleToast?.message} onDismiss={hideToast} />
      {children}
    </ToastContext.Provider>
  )
}

ToastProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
}

export default ToastProvider
